import useLang from "../../hooks/useLang";
import { PageHeader } from "../../components/Header";
import useProjectList from "./hooks/useProjectList";
import Button from "../../components/Button";
import { SplitGroup } from "../../components/Group";
// import ProjectCreatorMultimodal from "./ProjectCreatorMultimodal";
import CompletionModifier from "./CompletionModifier";
import DynamicTable from "../../components/DynamicTable";
import { ProjectStatusChangerControlled } from "./ProjectStatusChanger";
import Paging from "../../components/Paging";
import ModifierModal from "../../components/ModifierModal";
import Label from "../../components/Label";
import Input from "../../components/Input";
import DropdownSelector from "../../components/DropdownSelector";
import { ParamLinkTabs } from "../../components/Tabs";
import { BundleGroup } from "../../components/Group";
import RecordCounter from "../../components/RecordCounter";
import BillingModifier from "./BillingModifier";

const ProjectList = () => {
  const lang = useLang();
  const {
    tableAttribs,
    completionDialogAttribs,
    statusChangerAttribs,
    copy,
    totalPages,
    scopeInput,
    scopeModifierAttribs,
    qtyInput,
    qtyModifierAttribs,
    uomSelector,
    uomModifierAttribs,
    amountInput,
    amountModifierAttribs,
    billingDropdown,
    hourlyInput,
    hourlyModifierAttribs,
    warrantyInput,
    warrantyModifierAttribs,
    billingModifierAttribs,
    tabs,
    recordCount,
    clientDropdown,
    organizationDropdown,
    billingDropdownFilter,
  } = useProjectList();

  return (
    <>
      <PageHeader>
        <h1>{lang("projects")}</h1>
      </PageHeader>
      <BundleGroup>
        <BundleGroup>
          <Label>{lang("client")}</Label>
        </BundleGroup>
        <BundleGroup width={48}>
          <DropdownSelector {...clientDropdown} searchable />
        </BundleGroup>
        <BundleGroup width={4} />
        <BundleGroup>
          <Label>{lang("organisation")}</Label>
        </BundleGroup>
        <BundleGroup width={48}>
          <DropdownSelector {...organizationDropdown} />
        </BundleGroup>
        <BundleGroup width={4} />
        <BundleGroup>
          <Label>{lang("billing")}</Label>
        </BundleGroup>
        <BundleGroup width={48}>
          <DropdownSelector {...billingDropdownFilter} />
        </BundleGroup>
      </BundleGroup>
      <div style={{ height: "var(--spacing-4)" }} />
      <ParamLinkTabs tabs={tabs}>
        <>
          <SplitGroup />
          <Button emphasized onClick={copy}>
            {lang("copy")}
          </Button>
        </>
      </ParamLinkTabs>
      <Paging totalPages={totalPages} withPageSize />
      <RecordCounter recordCount={recordCount} />
      <DynamicTable {...tableAttribs} />
      <CompletionModifier {...completionDialogAttribs} />
      <Paging totalPages={totalPages} />
      <ProjectStatusChangerControlled {...statusChangerAttribs} />
      <ModifierModal {...scopeModifierAttribs}>
        <BundleGroup>
          <Input
            label={lang("planned_scope")}
            type="number"
            {...scopeInput.attributes}
          />
        </BundleGroup>
      </ModifierModal>
      <ModifierModal {...qtyModifierAttribs}>
        <BundleGroup>
          <Input label={lang("qty")} type="number" {...qtyInput.attributes} />
        </BundleGroup>
      </ModifierModal>
      <ModifierModal {...uomModifierAttribs}>
        <BundleGroup>
          <DropdownSelector {...uomSelector} />
        </BundleGroup>
      </ModifierModal>
      <ModifierModal {...hourlyModifierAttribs}>
        <BundleGroup>
          <Input
            label={lang("planned_hourly")}
            type="number"
            {...hourlyInput.attributes}
          />
        </BundleGroup>
      </ModifierModal>
      <ModifierModal {...warrantyModifierAttribs}>
        <BundleGroup>
          <Input
            label={lang("planned_warranty")}
            labelWidth={32}
            type="number"
            {...warrantyInput.attributes}
          />
        </BundleGroup>
      </ModifierModal>
      <ModifierModal {...amountModifierAttribs}>
        <BundleGroup>
          <Input
            label={lang("total_amount")}
            type="number"
            {...amountInput.attributes}
          />
        </BundleGroup>
      </ModifierModal>
      <BillingModifier
        {...{
          billingModifierAttribs,
          billingDropdown,
          scopeInput,
          hourlyInput,
        }}
      />
    </>
  );
};

export default ProjectList;
